export default "__VITE_ASSET__D1NDPB3W__"